import { Injectable } from '@angular/core';
import { AccountInfo, InteractionStatus } from '@azure/msal-browser';
import { UserRole } from '../guards/userRole';
import { AssignedRolesInfo } from '../types';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Observable, Subject, filter, map, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountRolesService {
  constructor(
    private msalBroadcastService: MsalBroadcastService, 
    private authService: MsalService
  ) {}

  getActiveAccountRoles(destroying: Subject<void>): Observable<AssignedRolesInfo> {
    return this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(destroying)
      )
      .pipe(map(() => {
        const activeAccount = this.authService.instance.getActiveAccount();
        return this.getAssignedRoles(activeAccount);
      }));
    ;
  }

  getAssignedRoles(accountInfo: AccountInfo | null): AssignedRolesInfo {
    return {
      IsInNewFcaAdmin: accountInfo?.idTokenClaims?.roles?.includes(UserRole.NewFcaAdmin) ?? false,
      IsInNewFcaAnalysisTeam: accountInfo?.idTokenClaims?.roles?.includes(UserRole.NewFcaAnalysisTeam) ?? false,
      IsInNewFcaManagementTeam: accountInfo?.idTokenClaims?.roles?.includes(UserRole.NewFcaManagementTeam) ?? false,
      IsInNewFcaReadOnly: accountInfo?.idTokenClaims?.roles?.includes(UserRole.NewFcaReadOnly) ?? false,
      IsInNewFcaSettlementTeam: accountInfo?.idTokenClaims?.roles?.includes(UserRole.NewFcaSettlementTeam) ?? false
    }
  }
}